import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCryptopunk: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCryptopunk"><Path fillRule="evenodd" clipRule="evenodd" d="M6.5 2H17.5V3.5H6.5V2ZM6.5 6V3.5H5V9H3.5V14.5H5V22H12V20H17.5V18.5H19V7.5H22V6H19V3.5H17.5V6H6.5ZM9.96875 9.19444H11.4791V10.6944H9.96875V9.19444ZM14.0938 9.19444H15.6041V10.6944H14.0938V9.19444ZM10 13H11.51V14.5H15V16H11V14.5H10V13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCryptopunk;
